import { Component, OnInit, ViewChild, Input, AfterViewInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { ProfileService } from '@service/profile.service';
import { AuthService } from '@service/auth.service';
import { Profile } from '@model/Profile';
import { Message } from '@model/Message';

import * as moment from 'moment';

const knowledgement_areas = [
  {
    name: 'Ciências Agrárias',
    subcategories: [
      { name: 'Agronomia' },
      { name: 'Ciência e Tecnologia de Alimentos' },
      { name: 'Medicina Veterinária' },
      { name: 'Recursos Florestais e Engenharia Florestal' },
      { name: 'Recursos Pesqueiros e Engenharia de Pesca' },
      { name: 'Zootecnia' }
    ]
  },
  {
    name: 'Ciências Biológicas',
    subcategories: [
      { name: 'Biofísica' },
      { name: 'Biologia Geral' },
      { name: 'Bioquímica' },
      { name: 'Biotecnologia' },
      { name: 'Botânica' },
      { name: 'Ecologia' },
      { name: 'Farmacologia' },
      { name: 'Fisiologia' },
      { name: 'Genética' },
      { name: 'Imunologia' },
      { name: 'Microbiologia' },
      { name: 'Morfologia' },
      { name: 'Parasitologia' },
      { name: 'Zoologia' },
    ]
  },
  {
    name: 'Ciências da Saúde',
    subcategories: [
      { name: 'Educação Física' },
      { name: 'Enfermagem' },
      { name: 'Farmácia' },
      { name: 'Fisioterapia e Terapia' },
      { name: 'Ocupacional' },
      { name: 'Fonoaudiologia' },
      { name: 'Medicina' },
      { name: 'Nutrição' },
      { name: 'Odontologia' },
      { name: 'Saúde Coletiva' }
    ]
  },
  {
    name: 'Ciências Exatas e da Terra',
    subcategories: [
      { name: 'Astronomia' },
      { name: 'Ciência da Computação' },
      { name: 'Física' },
      { name: 'Geociências' },
      { name: 'Matemática' },
      { name: 'Oceanografia' },
      { name: 'Probabilidade e Estatística Química' },
      { name: 'Química' }
    ]
  },
  {
    name: 'Ciências Humanas',
    subcategories: [
      { name: 'Antropologia' },
      { name: 'Arqueologia' },
      { name: 'Ciência Política' },
      { name: 'Educação' },
      { name: 'Filosofia' },
      { name: 'Geografia' },
      { name: 'História' },
      { name: 'Psicologia' },
      { name: 'Sociologia' },
      { name: 'Teologia' },
    ]
  },
  {
    name: 'Ciências Sociais Aplicadas',
    subcategories: [
      { name: 'Administração' },
      { name: 'Arquitetura e Urbanismo' },
      { name: 'Ciência da Informação' },
      { name: 'Ciências Contábeis' },
      { name: 'Comunicação' },
      { name: 'Demografia' },
      { name: 'Desenho Industrial' },
      { name: 'Direito' },
      { name: 'Economia' },
      { name: 'Economia Doméstica' },
      { name: 'Museologia' },
      { name: 'Planejamento Urbano e Regional' },
      { name: 'Serviço Social' },
      { name: 'Turismo' }
    ]
  },
  {
    name: 'Engenharias',
    subcategories: [
      { name: 'Engenharia Aeroespacial' },
      { name: 'Engenharia Biomédica' },
      { name: 'Engenharia Civil' },
      { name: 'Engenharia de Energia' },
      { name: 'Engenharia de Materiais e Metalúrgica' },
      { name: 'Engenharia de Minas' },
      { name: 'Engenharia de Produção' },
      { name: 'Engenharia de Transportes' },
      { name: 'Engenharia Elétrica' },
      { name: 'Engenharia Mecânica' },
      { name: 'Engenharia Naval e Oceânica' },
      { name: 'Engenharia Nuclear' },
      { name: 'Engenharia Química' },
      { name: 'Engenharia Sanitária' }
    ]
  },
  {
    name: 'Linguísticas, Letras e Artes',
    subcategories: [
      { name: 'Artes' },
      { name: 'Letras' },
      { name: 'Linguistica' }
    ]
  },
  {
    name: 'Outra',
    subcategories: [
      { name: 'Outra' }
    ]
  }
]

interface Country {
  name: string;
  code: string;
}

@Component({
  selector: 'app-modal-student-profile',
  templateUrl: './modal-student-profile.component.html',
  styleUrls: ['./modal-student-profile.component.scss']
})
export class ModalStudentProfileComponent implements OnInit, AfterViewInit {

  @ViewChild('knowledgementAreaInput', { static: false }) knowledgementAreaInput: any;
  @ViewChild('knowledgementSubareaInput', { static: false }) knowledgementSubareaInput: any;
  @ViewChild('knowledgementAreaInputDefaultOption', { static: false }) knowledgementAreaInputDefaultOption: any;

  @ViewChild('cityInputDefaultOption', { static: false }) cityInputDefaultOption: any;

  @Input() institutionData = null;

  public form: FormGroup;
  public ies: any[] = [];
  public cities: any[] = [];
  public knowledgement_areas: any[] = knowledgement_areas;
  public knowledgement_subareas: any[] = [];

  public submitted: boolean;
  public loading: boolean;

  public countries: Country[] = [];

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private toast: ToastrService,
    private profileService: ProfileService,
    private authenticationService: AuthService
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      affiliation: ['', Validators.required],
      uf: ['', Validators.required],
      city_cod: ['', Validators.required],
      knowledgement_area: ['', Validators.required],
      country: ['', Validators.required]
    });
    this.getCountries();
  }

  save(): void {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    const formData: any = this.form.value;
    const info: any = {
      affiliation: {
        name: formData.affiliation.toUpperCase(),
        address: {
          uf: formData.uf,
          city: this.cities.find(c => c.co_municipio === formData.city_cod)
        }
      },
      knowledgement_area: {
        area: this.knowledgementAreaInput.nativeElement.value,
        subarea: formData.knowledgement_area
      },
      country: this.countries.find(c => c.code === formData.country)
    };
    
    this.submitted = false;

    if (this.institutionData === null) {
      this.profileService.store_student_affiliation(info)
        .subscribe(() => {
          this.authenticationService.profile()
            .subscribe((user: any) => {
              const differenceInDays = moment(user.voucher_expires_at, 'YYYY-MM-DD').diff(new Date(), 'days');
              const profile: Profile = {
                name: user.name,
                email: user.email,
                role: user.role,
                url_image: user.url_image,
                profile_type: user.profile_type,
                voucher_expires_at: String(differenceInDays < 0 ? 0 : differenceInDays),
                is_superuser: user.is_superuser,
                is_institution: user.is_institution,
                student_institution: user.student_institution,
                code: user.code,
              };

              localStorage.setItem('currentUser', JSON.stringify(profile));

              this.toast.success(Message.SUCCESS);
              this.activeModal.close();
            });
        });
    } else {
      this.profileService.update_student_affiliation(this.institutionData.id, info)
        .subscribe(() => {
          const currentUser = this.authenticationService.user;
          currentUser.student_institution.info = Object.assign({}, currentUser.student_institution.info, info);
          const profile: Profile = {
            name: currentUser.name,
            email: currentUser.email,
            role: currentUser.role,
            url_image: currentUser.url_image,
            attending: currentUser.attending,
            profile_type: currentUser.profile_type,
            voucher_expires_at: currentUser.voucher_expires_at,
            is_superuser: currentUser.is_superuser,
            is_institution: currentUser.is_institution,
            student_institution: currentUser.student_institution,
            code: currentUser.code
          };

          localStorage.setItem('currentUser', JSON.stringify(profile));

          this.toast.success(Message.SUCCESS);
          this.activeModal.close();
        });
    }

  }

  logout() {
    this.authenticationService.disconnect().subscribe(() => {
      this.authenticationService.logout();
    });
  }

  getCountries(): void {
    this.profileService.getCountries().subscribe(
      (res: Country[]) => {
        this.countries = res;
      }
    )
    if (this.institutionData) {
      this.form.patchValue({
        country: this.institutionData.info.country.code
      });
    }
  }


  questIES(questInput: any): void {
    if (questInput) {
      this.loading = true;
      this.profileService.questIES(questInput)
        .subscribe((res: any[]) => {
          this.ies = res;
          this.loading = false;
        }, () => this.loading = false);
    }
  }

  choiceIES(ie: string): void {
    this.form.patchValue({
      affiliation: this.formatIESName(ie)
    });
    this.ies = [];
  }

  choiceUF(ufInput: string, $cityInputDefaultOption: any): void {
    $cityInputDefaultOption.label = 'Carregando...';
    this.profileService.questCities(ufInput).subscribe(
      (res: any) => {
        $cityInputDefaultOption.label = 'Selecione...';
        this.cities = res;
        if (this.institutionData) {
          this.form.patchValue({
            city_cod: this.institutionData.info.affiliation.address.city.co_municipio
          });
        }
      }
    );
  }

  questKnowledgementSubareas(knowledgementAreaInput: any, $knowledgementAreaInputDefaultOption: any): void {
    $knowledgementAreaInputDefaultOption.label = 'Carregando...';
    const knowledgement_subareas = this.knowledgement_areas.find(item => item.name === knowledgementAreaInput).subcategories;
    this.knowledgement_subareas = knowledgement_subareas;
    $knowledgementAreaInputDefaultOption.label = 'Selecione...';
    if (this.institutionData) {
      this.form.patchValue({
        knowledgement_area: this.institutionData.info.knowledgement_area.subarea
      });
    }
  }


  private formatIESName(ie: any): string {
    const ies = ie.ies;
    const match = ies.match(/\(\d+\) /)[0];
    const sigla = ie.sigla.length > 1 ? ` - ${ie.sigla}` : ''
    return ies.replace(match, '').trim() + sigla;
  }

  ngAfterViewInit() {
    if (this.institutionData) {
      setTimeout(() => {
        this.knowledgementAreaInput.nativeElement.value = this.institutionData.info.knowledgement_area.area;
        this.questKnowledgementSubareas(this.knowledgementAreaInput.nativeElement.value, this.knowledgementAreaInputDefaultOption);


        this.form.patchValue({
          affiliation: this.institutionData.info.affiliation.name,
          uf: this.institutionData.info.affiliation.address.uf
        });
        this.choiceUF(this.institutionData.info.affiliation.address.uf, this.cityInputDefaultOption);
      }, 0);
    }
  }

}
